import supported from './isSupoortObjectDefineProperty';

export function isObject (obj){
    return Object.prototype.toString.call(obj) === '[object Object]';
}

export function isArray (obj){
    return Object.prototype.toString.call(obj) === '[object Array]';
}

export function isDate (obj){
  return Object.prototype.toString.call(obj) === '[object Date]';
}

export function isReg (obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

var class2type = (function () {
    var class2type = {};
    var arr = "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" ");
    arr.forEach(function (name) {
      class2type["[object " + name + "]"] = name.toLowerCase();
    });
    return class2type;
  })();
  
var _type = function (obj) {
    if (obj == null) {
      return obj + "";
    }
    return typeof obj === "object" || typeof obj === "function" ?
      class2type[{}.toString.call(obj)] || "object" :
      typeof obj;
};

var isFunction = function (obj) {
    return _type(obj) === "function";
};
  
var isPlainObject = function (obj) {
    return _type(obj) === 'object';
};

export function extend () {
    var src, copyIsArray, copy, name, options, clone,
      target = arguments[0] || {},
      i = 1,
      length = arguments.length,
      deep = false;
  
    // Handle a deep copy situation
    if (typeof target === "boolean") {
      deep = target;
  
      // skip the boolean and the target
      target = arguments[i] || {};
      i++;
    }
  
    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== "object" && !isFunction(target)) {
      target = {};
    }
  
    // extend jQuery itself if only one argument is passed
    if (i === length) {
      target = this;
      i--;
    }
  
    for (; i < length; i++) {
  
      // Only deal with non-null/undefined values
      if ((options = arguments[i]) != null) {
  
        // Extend the base object
        for (name in options) {
          src = target[name];
          copy = options[name];
  
          // Prevent never-ending loop
          if (target === copy) {
            continue;
          }
  
          // Recurse if we're merging plain objects or arrays
          if (deep && copy && (isPlainObject(copy) ||
            (copyIsArray = isArray(copy)))) {
  
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && isArray(src) ? src : [];
  
            } else {
              clone = src && isPlainObject(src) ? src : {};
            }
  
            // Never move original objects, clone them
            target[name] = extend(deep, clone, copy);
  
            // Don't bring in undefined values
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    }
  
    // Return the modified object
    return target;
};

export function scanAndCompare (newObj, oldObj, is_not_root) {
    for(let key in newObj) {
        if (oldObj.hasOwnProperty(key)) {
            if (typeof newObj[key] !== typeof oldObj[key]) {
                if (supported) {
                  oldObj[key] = newObj[key];
                } else if (typeof oldObj.__vm__set === 'function'){
                  oldObj.__vm__set(key, newObj[key]);
                } else {
                  oldObj[key] = newObj[key];
                }
            } else {
                if (isEmpty(newObj[key]) || isEmpty(oldObj[key])) {
                  if (supported) {
                    oldObj[key] = newObj[key];
                  } else if (typeof oldObj.__vm__set === 'function'){
                    oldObj.__vm__set(key, newObj[key]);
                  } else {
                    oldObj[key] = newObj[key];
                  }
                } else if (isObject(newObj[key])) {
                    scanAndCompare(newObj[key], oldObj[key], true);
                } else if(isArray(newObj[key])){
                  if (supported) {
                    oldObj[key] = newObj[key];
                  } else if (typeof oldObj.__vm__set === 'function'){
                    oldObj.__vm__set(key, newObj[key]);
                  } else {
                    oldObj[key] = newObj[key];
                  }
                } else {
                  if (supported) {
                    oldObj[key] = newObj[key];
                  } else if (typeof oldObj.__vm__set === 'function'){
                    oldObj.__vm__set(key, newObj[key]);
                  } else {
                    oldObj[key] = newObj[key];
                  }
                }
            }
        } else {
          if (supported) {
            oldObj[key] = newObj[key];
          } else if (typeof oldObj.__vm__set === 'function'){
            oldObj.__vm__set(key, newObj[key]);
          } else {
            oldObj[key] = newObj[key];
          }
        }
    }
    let vm_ignore_properties = ['__vm__get', '__vm__hash', '__vm__set'];
    if (is_not_root) {
        for(let key in oldObj) {
            if (vm_ignore_properties.indexOf(key) < 0 && !newObj.hasOwnProperty(key)) {
                oldObj[key] = undefined;
                delete oldObj[key];
            }
        }
    }
}

export function scanAndSet (newObj, oldObj, clear) {
  for(let key in newObj) {
      if (oldObj.hasOwnProperty(key)) {
          if (typeof newObj[key] !== typeof oldObj[key]) {
              oldObj[key] = newObj[key];
          } else {
              if (isObject(newObj[key]) && isObject(oldObj[key])) {
                scanAndSet(newObj[key], oldObj[key], true);
              } else if(isArray(newObj[key])){
                oldObj[key] = newObj[key];
              } else {
                oldObj[key] = newObj[key];
              }
          }
      } else {
        oldObj[key] = newObj[key];
      }
  }
  if (clear) {
    for(let key in oldObj) {
        if (!newObj.hasOwnProperty(key)) {
            delete oldObj[key];
        }
    }
  }
}

export function isSameObject(a, b) {
    let result = true;
    if (isObject(a) && isObject(b)) {
        let a_keys = Object.keys(a);
        let b_keys = Object.keys(b);
        if (a_keys.length != b_keys.length) {
            return result;
        }
        for(let a_key in a) {
            if (!a_key) {
              continue;
            }
            if (!b.hasOwnProperty(a_key)) {
                result = false;
                break;
            } else if (isObject(b[a_key]) && isObject(a[a_key])) {
                if (!isSameObject(b[a_key], a[a_key])) {
                  result = false
                }
            } else if (isArray(b[a_key]) && isArray(a[a_key])) {
              if (!isSameObject(b[a_key], a[a_key])) {
                result = false
              }
            } else if (b[a_key] !== a[a_key]){
                result = false;
                break;
            }
        }
        for(let b_key in b) {
            if (!b_key) {
              continue;
            }
            if (!a.hasOwnProperty(b_key)) {
                result = false;
                break;
            } else if (isObject(b[b_key]) && isObject(a[b_key])) {
              if (!isSameObject(b[b_key], a[b_key])) {
                result = false
              }
            } else if (isArray(b[b_key]) && isArray(a[b_key])) {
              if (!isSameObject(b[b_key], a[b_key])) {
                result = false
              }
            } else if (b[b_key] !== a[b_key]){
                result = false;
                break;
            }
        }
    } else if (isArray(a) && isArray(b)) {
      if (a.length !== b.length) {
        return false;
      } else {
        for(let index = 0;index < a.length;index++) {
          if (!isSameObject(a[0], b[0])) {
            result = false;
            break;
          }
        }
      }
    } else if (isDate(a) && isDate(b)) {
        return a.getTime() === b.getTime();
    } else if (isReg(a) && isReg(b)) {
        return reg.valueOf() === reg.valueOf();
    } else {
        return a === b;
    }
    return result;
}

export function isEmpty (input) {
  return input + '' === 'null' || input + '' === 'undefined' || input === '';
};